import { elevatedCardStyles } from './ElevatedCard.styles';
import { filledCardStyles } from './FilledCard.styles';
import { outlinedCardStyles } from './OutlinedCard.styles';
export const cardVariantStyles = {
    elevated: elevatedCardStyles,
    filled: filledCardStyles,
    outlined: outlinedCardStyles,
};
